import axios from "axios";
import store from "@/store/index.js";
import router from "@/router/index.js";
import windowConfig from "@/window.js";
axios.defaults.baseURL = windowConfig.baseUrl;
axios.interceptors.request.use(function (config) {
    let token = store.getters.authToken || sessionStorage.getItem("authToken") || undefined;
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, (err) => {
    return Promise.reject(err);
});

axios.interceptors.response.use(response => {
    return response.data;
}, err => {
    if (err && err.response) {
        switch (err.response.status) {
        case 401:
            err.msg = "请先登录";
            break;
        }
    } else {
        err.msg = "网络连接错误";
    }
    return Promise.reject(err);
});

export function $get ({ url, params = {}, callback }) {
    return axios({
        method: "get",
        url: url,
        params
    }).then(response => {
        callback && callback(response.data);
        return response;
    }).catch((err) => {
        this.$Message.error(err);
    });
};

export function $post ({ url, data = {}, callback }) {
    return axios.post(url, data).then((response) => {
        if (response.code === 0) {
            callback && callback(response.data);
        } else {
            this.$Message.error(response.message);
        }
        return response;
    }).catch((err) => {
        console.log(err);
        this.$Message.error(err.msg || "操作失败");
        if (err && err.response && err.response.status === 401) {
            store.commit("clearUserInfo");
            router.replace({
                name: "login"
            });
        }
    });
};



// WEBPACK FOOTER //
// ./src/data/http.js